// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserProfileImage_wrapper","background":"UserProfileImage_background","quote":"UserProfileImage_quote"};